/*
 * $Id:: TableSortHead.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import { t } from '../../../../../providers';

const TableSortHead = ({ classes, sortBy, sortValue, setSorting }) => {
    const sortHeader = (event, sortBy) => {
        event.preventDefault();
        setSorting(sortBy);
    };

    return (
        <TableHead>
            <TableRow className={classes.row}>
                <TableCell className={classes.name} align="left">
                    {t('name')}
                </TableCell>
                <TableCell className={classes.email} align="left">
                    {t('email')}
                </TableCell>
                <TableCell className={classes.userID} align="left">
                    {t('user.id')}
                </TableCell>
                <TableCell className={classes.status} align="left">
                    {t('status')}
                </TableCell>
                <TableCell className={classes.roles} align="left">
                    {t('roles')}
                </TableCell>
                <TableCell className={classes.actions} align="left">
                    {t('options')}
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

export default TableSortHead;
